import { combineReducers } from 'redux'
import categorias from './categorias';
import productos from './productos';
import promociones from './promociones';
import productosPromocion from "./productosPromocion";
import aplicacionesLaborales from "./aplicacionesLaborales";

const appReducers = combineReducers({
    categorias,
    productos,
    promociones,
    productosPromocion,
    aplicacionesLaborales
});

export default appReducers;


// WEBPACK FOOTER //
// ./src/reducers/index.js